
<template>
  <div>
    <Theme1NavBar :company="company" />

    <main>
      <Theme1HomePagePart1Hero :years="company.years" />
      <Theme1HomePagePart2Services />
      <Theme1HomePagePart3WhyUs />
      <Theme1HomePagePart4CTA :company="company" />
    </main>

    <Theme1Footer :company="company" />
  </div>
</template>

<script>
import Theme1NavBar from '@/Theme1NavBar.vue';
import Theme1HomePagePart1Hero from '@/Theme1HomePagePart1Hero.vue';
import Theme1HomePagePart2Services from '@/Theme1HomePagePart2Services.vue';
import Theme1HomePagePart3WhyUs from '@/Theme1HomePagePart3WhyUs.vue';
import Theme1HomePagePart4CTA from '@/Theme1HomePagePart4CTA.vue';
import Theme1Footer from '@/Theme1Footer.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
  name: 'Theme1HomePage',
  components: {
    Theme1NavBar,
    Theme1HomePagePart1Hero,
    Theme1HomePagePart2Services,
    Theme1HomePagePart3WhyUs,
    Theme1HomePagePart4CTA,
    Theme1Footer,
  },
  data() {
    return {
      company: {
        name: 'Ironline Services',
        tagline: 'Trucking & Freight',
        blurb: 'Logistics for businesses, and fleets across the region.',
        phone: '(555) X19-4820',
        phoneHref: '+1555X194820',
        email: 'dispatch@ironlineserv.exp',
        address: '1420 Foundry Ave, Suite 5',
        hours: 'Office Mon–Fri 7a–6p · Emergency 24/7',
        license: 'Lic. # · # · DOT 1550372',
        years: 18,
      },
    };
  },
  mounted() {
    document.title = `Theme 1`;
    document.body.classList.add('t1-body');
    AOS.init({ duration: 650, once: true, offset: 60 });
  },
  beforeUnmount() {
    document.body.classList.remove('t1-body');
  },
};
</script>

<style src="@/styles/theme1MainStyles.css"></style>
